import Home from './routes/Home.svelte';

export default {
    '/': Home,
    '*': Home,
};
